import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './CircleImage.module.css'; // Create this CSS file

// Import your local image (adjust the path as needed)
import localImage from './assets/dubaiChocolate.png';

const CircleImage = props => {
  const {
    className,
    rootClassName,
    alt = 'Profile image',
    imageSrc = localImage, // Default to imported image if none provided
    size = 'medium', // small, medium, large
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className, css[size]);

  return (
    <div className={classes}>
      <img src={imageSrc} alt={alt} className={css.image} {...rest} />
    </div>
  );
};

CircleImage.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  alt: PropTypes.string,
  imageSrc: PropTypes.string, // Path to local image
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default CircleImage;
